var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "solutionguide__breadcrumb" },
    [
      _vm.isMobile
        ? [
            _c(
              "div",
              {
                staticClass: "solutionguide__step solutionguide__step--active",
              },
              [_vm._v(_vm._s(_vm.$t(_vm.activeStep + ".step")))]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "solutionguide__stepcount" }, [
              _vm._v(
                "(" +
                  _vm._s(_vm.activeStepNo) +
                  "/" +
                  _vm._s(_vm.totalStepCount) +
                  ")"
              ),
            ]),
          ]
        : [
            _vm._l(Object.values(_vm.steps), function (step, index) {
              return [
                index > 0
                  ? _c("div", { staticClass: "solutionguide__divider" })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "solutionguide__step",
                    class: _vm.isActiveStep(step)
                      ? "solutionguide__step--active"
                      : _vm.isPreviousStep(step)
                      ? "solutionguide__step--prev"
                      : "",
                    on: { click: () => _vm.goBackToStep(step) },
                  },
                  [_vm._v(_vm._s(_vm.$t(step + ".step")))]
                ),
              ]
            }),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }